import React from 'react';

const Information = (props) => {
    return (
        <div className="blk blk-result-info"><h4>{props.infomsg}</h4></div>
    )
}

export default Information
